import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditOverviewComponent } from '../../business/edit-overview/edit-overview.component';
import { AviationEventsService } from '../../shared/services/aviation-events.service';

@Component({
  selector: 'app-edit-event-short-description',
  templateUrl: './edit-event-short-description.component.html',
  styleUrls: ['./edit-event-short-description.component.scss']
})
export class EditEventShortDescriptionComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  charRemainingCnt: number;
  _originDesc: string;
  _MAX_CHARACTERS = 200;
  isBusy = false;

  constructor(private _matDialogRef: MatDialogRef<EditOverviewComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService) {
    this.aviationEvent = data.aviationEvent;
    this.charRemainingCnt = this.aviationEvent.shortDescription ?
      this._MAX_CHARACTERS - this.aviationEvent.shortDescription.length : this._MAX_CHARACTERS;
    this._originDesc = this.aviationEvent.shortDescription;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = new FormGroup({
      shortDescription: new FormControl('', [Validators.required, Validators.maxLength(this._MAX_CHARACTERS)])
    });
  }

  cancel () {
    this.aviationEvent.shortDescription = this._originDesc;
    this._matDialogRef.close(null);
  }

  textAreaChanged () {
    this.charRemainingCnt = this.aviationEvent.shortDescription.length <= this._MAX_CHARACTERS ?
      this._MAX_CHARACTERS - this.aviationEvent.shortDescription.length : 0;
  }

  async save () {
    if (this.aviationEvent.shortDescription) {
      this.aviationEvent.shortDescription = this.aviationEvent.shortDescription.trim();
    }
    try {
      this.isBusy = true;
      await this._aviationEventsService.updateAviationEvent(this.aviationEvent);
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }
  }
}
